<div class="app-body">
  <main class="main d-flex align-items-center">
    <div class="container" style="margin-top: 5%">
      <div class="text-center">
        <img src="assets/img/brand/sygnet.png" alt="LC+" style="margin: 30px auto; width: 320px" />
      </div>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <div class="card-group">
            <div class="card">
              <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
                  <p class="text-dangegr">{{ message }}</p>
                  <div class="input-group mb-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-user"></i></span>
                    </div>
                    <input type="text" formControlName="email" class="form-control" />
                  </div>
                  <div class="input-group mb-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-lock"></i></span>
                    </div>
                    <input
                      type="password"
                      formControlName="password"
                      class="form-control"
                      placeholder="New Password"
                      [ngClass]="getValidationClass('password')" />
                  </div>
                  <div class="input-group mb-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-lock"></i></span>
                    </div>
                    <input
                      type="password"
                      formControlName="repeatPassword"
                      class="form-control"
                      placeholder="Repeat New Password"
                      [ngClass]="getValidationClass('repeatPassword')" />
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <ul style="list-style: none">
                        <li>
                          <i [ngStyle]="{ color: passwordValidation().min ? 'green' : 'red' }" class="fa fa-check"> </i>
                          Minimum length of 10 characters
                        </li>
                        <li>
                          <i [ngStyle]="{ color: passwordValidation().sum ? 'green' : 'red' }" class="fa fa-check"> </i>
                          Must use three of the four:
                          <ul style="list-style: none; padding-left: 20px">
                            <li>
                              <i
                                [ngStyle]="{
                                  color: passwordValidation().lower
                                    ? 'green'
                                    : passwordValidation().sum
                                      ? '#aaa'
                                      : 'red'
                                }"
                                class="fa fa-check"></i>
                              Lowercase
                            </li>
                            <li>
                              <i
                                [ngStyle]="{
                                  color: passwordValidation().upper
                                    ? 'green'
                                    : passwordValidation().sum
                                      ? '#aaa'
                                      : 'red'
                                }"
                                class="fa fa-check"></i>
                              Uppercase
                            </li>
                            <li>
                              <i
                                [ngStyle]="{
                                  color: passwordValidation().number
                                    ? 'green'
                                    : passwordValidation().sum
                                      ? '#aaa'
                                      : 'red'
                                }"
                                class="fa fa-check"></i>
                              Number
                            </li>
                            <li>
                              <i
                                [ngStyle]="{
                                  color: passwordValidation().symbol
                                    ? 'green'
                                    : passwordValidation().sum
                                      ? '#aaa'
                                      : 'red'
                                }"
                                class="fa fa-check"></i>
                              Symbol
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-8">
                      <button type="submit" class="btn btn-primary px-4" [disabled]="!form.valid">
                        Update Password
                      </button>
                    </div>
                    <div class="col-4 text-right">
                      <a routerLink="/login" class="btn btn-link px-0">Login</a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
